export default __webpack_public_path__ + "static/media/eyes.5fb02bc5.svg";